import { UiSchema } from '@rjsf/utils';

export const UI_SCHEMAS_LIBRARY: Record<string, UiSchema> = {
	default: {},
};
